import { AuthSession } from '@/types'
import { useSession } from 'next-auth/react'

export const useAuthSession = (): AuthSession => {
  // only for testing - check AuthWrapper.cy.tsx for examples
  if (process.env.MOCK_AUTH_SESSION) {
    return JSON.parse(process.env.MOCK_AUTH_SESSION) as AuthSession
  }

  // cause of the mock above
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { status: sessionStatus, data: user } = useSession()
  const authenticated = sessionStatus === 'authenticated'
  const unauthenticated = sessionStatus === 'unauthenticated'
  const loading = sessionStatus === 'loading'

  return { authenticated, unauthenticated, loading, user }
}
